export default __webpack_public_path__ + "static/media/Mada_Logo.11ab2927.svg";